import { Company } from "./Company";

export interface AccountStateModel {
  currentCompany: Company | null;
  companies: Company[];
  loadingCompanies: boolean;
  setCurrentCompany : (company: Company) => void;
  removeCurrentCompany : (company: Company) => void;
  addCompanies : (company: Company[]) => void;
  removeCompanies  : () => void;
  removeCompany : (company : Company) => void;
  updateCompany : (company: Company) => void;
  addCompany : (company : Company) => void;
  setLoadingCompanies: (loading: boolean) => void;
}
export const initialAccountState: AccountStateModel = {
  currentCompany: null,
  companies: [],
  setCurrentCompany : () => undefined,
  removeCurrentCompany : () => undefined,
  addCompanies : () => undefined,
  removeCompany : () => undefined,
  removeCompanies : () => undefined,
  updateCompany : () => undefined,
  addCompany : () => undefined,
  setLoadingCompanies: () => undefined,
  loadingCompanies: true
};
